import { useCallback } from "react";
import { useLocation } from "react-router-dom";

interface UseSidebarRouteActiveReturn {
  isRouteActive: (route: string) => boolean;
}

function useSidebarRouteActive(): UseSidebarRouteActiveReturn {
  const { pathname } = useLocation();

  /**
   * Matches on path segments rather than a bare substring. A substring test
   * marks unrelated items active whenever one route's path happens to be a
   * prefix of another's — `/upgrade/groups-and-monitoring` contains `/groups`,
   * which lit up the Groups item while the Groups upsell page was open.
   *
   * Nested paths still match their section (`/dashboards/123` → `/dashboards`).
   */
  const isRouteActive = useCallback(
    (route: string) => {
      if (route === "/live" && pathname === "/") return true;

      return pathname === route || pathname.startsWith(`${route}/`);
    },
    [pathname]
  );

  return { isRouteActive };
}

export default useSidebarRouteActive;
